import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import featureFlags from "../../authorization/constants/featureFlags";
import useFeatureFlag from "../../authorization/hooks/useFeatureFlag";
import useHasRight from "../../authorization/hooks/useHasRight";

import ExportPresetSettingsView from "../views/ExportPresetSettingsView/ExportPresetSettingsView";

export default function ExportPresetSettings() {
	const { organization } = useOutletContext();

	const hasRight = useHasRight();
	const hasFlatteningFeature = useFeatureFlag(featureFlags.FLATTENING);

	if (!hasFlatteningFeature || !hasRight("distributions.admin")) {
		return <Unauthorized />;
	}

	return <ExportPresetSettingsView publisher={organization} />;
}
